import React, { Component } from 'react';

export class ArtistInput extends Component {

    render() {
        return (
            <div>
                <input onChange = {e => this.props.parentThis.searchArtists(e) }  type="name" id="artistName" className="form-control my-2 artistName" placeholder="Artist" />  
                <label htmlFor="numberOfTracks" className="chooseNumberOfTracks">Choose the number of tracks</label>
                <select id="numberOfTracks" className="numberOfTracks" name="numberOfTracks" onChange={e => this.props.parentThis.setState({ numberOfTracks: e.target.value })}>
                    <option value="128">128 tracks</option>
                    <option value="64">64 tracks</option>
                    <option selected value="32">32 tracks</option>
                    <option value="16">16 tracks</option>
                    <option value="8">8 tracks</option>
                </select>
            </div>
        )
    }
    
}